import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    toasts: [],
};
let id = 0;
const toastsSlice = createSlice({
    name: 'toasts',
    initialState,
    reducers: {
        addNewToast: (state, action) => {
            state.toasts.push(action.payload);
        },
        removeToast: (state, action) => {
            state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
        },
        clearToasts: (state) => {
            state.toasts = [];
        },
    },
});
export const { addNewToast, removeToast, clearToasts } = toastsSlice.actions;
export const selectAllToasts = (state) => state.toasts.toasts;
export const addToast = (toast) => (dispatch) => {
    const values = toast || {
        color: 'negative',
    };
    dispatch(addNewToast(Object.assign(Object.assign({}, values), { id: (id += 1) })));
};
export default toastsSlice.reducer;
